import { render, staticRenderFns } from "./WordDetils.vue?vue&type=template&id=d27d5068&scoped=true&"
import script from "./WordDetils.vue?vue&type=script&lang=js&"
export * from "./WordDetils.vue?vue&type=script&lang=js&"
import style0 from "./WordDetils.vue?vue&type=style&index=0&id=d27d5068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27d5068",
  null
  
)

export default component.exports